import classNames from 'classnames';
import { DockPosition } from '@instinet-analytics/semantic-ui-components';
import { DockPositionEditor } from '@instinet-analytics/semantic-ui-components';
import { useIndexEventsConfigSlice } from '../store/config/configSlice';

export function IndexEventsSettings() {
    const { config, dispatchConfigChanged } = useIndexEventsConfigSlice();

    const onDockPositionChanged = (nextPos?: DockPosition) => {
        dispatchConfigChanged({ dockPosition: nextPos });
    };

    return (
        <div className={classNames('IndexEventsSettings')}>
            <div className="group">
                <div>
                    <div>Details Panel Position:</div>
                    <DockPositionEditor
                        position={config.dockPosition ?? 'Bottom'}
                        onChange={onDockPositionChanged}
                    />
                </div>
            </div>
        </div>
    );
}
